import { TooltipWrapper } from 'components/TooltipWrapper';
import type { WorkOrderOtherPriceData } from 'gql/graphql';
import { CodeCell } from 'pages/Project/Common/CodeCell';
import { Badge } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';

export const OtherStatusCellRendererComponent = (props: ICellRendererParams<WorkOrderOtherPriceData>) => {
    const { data } = props;

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {data?.hasLimitSpan ? (
                <TooltipWrapper message="Добавлено за счёт распределения лимитов" isInteractive={false}>
                    <Badge size="s" status="system" label="Л" />
                </TooltipWrapper>
            ) : (
                <div />
            )}
            {data?.status ? <CodeCell status={data.status} /> : <div />}
        </div>
    );
};

OtherStatusCellRendererComponent.displayName = 'OtherCodeCellRendererComponent';
